<template>
  <div class="d-flex justify-content-center container-geral">
    <div class="container-components">
      <b-card style="font-size: 12px; margin-top: 10px; padding: 1.5rem 0">
        <div class="generalContent">
          <div>
            <div class="rowContainer">
              <span>
                <b-icon-gear-fill></b-icon-gear-fill> Documentos Fiscais
              </span>
              <div class="rowContent">
                <div class="selectPlus">
                  <label class="fixedSelect2">Ambiente de Emissão</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="dataSettings.emissao_fiscal.ambiente"
                    :options="ambiente"
                  ></b-form-select>
                </div>
                <b-button
                  class="btnInutilizar"
                  @click="openInutilizarModal"
                >
                  Inutilizar Numeração
                </b-button>
                <div class="contentActiveVirtualManager">
                  <label for="active-infoAgroNfe">
                    Informações de agrotóxicos
                    <input
                      type="checkbox"
                      id="active-infoAgroNfe"
                      v-model="dataSettings.emissao_fiscal.infoAgroNfe"
                    />
                  </label>
                </div>
                <div class="contentActiveVirtualManager">
                  <label for="active-select-products-fiscal-document">
                    Selecionar produtos ao transformar venda em NF
                    <input
                      type="checkbox"
                      id="active-select-products-fiscal-document"
                      v-model="
                        dataSettings.emissao_fiscal
                          .selecionarProdutosAoTransformarVenda
                      "
                    />
                  </label>
                </div>
              </div>
            </div>

            <div class="rowContainer receitaSettings">
              <span>
                <b-icon-bag-check-fill></b-icon-bag-check-fill> Receita
              </span>
              <div class="receitaMainGrid">
                <div class="selectPlus">
                  <label class="fixedSelect2">Situação ao imprimir</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="dataSettings.receita.situacaoAoImprimir"
                    :options="situationsWhenPrinting"
                  ></b-form-select>
                </div>

                <div class="selectPlus">
                  <label class="fixedSelect2">Situação ao emitir NF-e</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="dataSettings.receita.situacaoAoEmitirNfe"
                    :options="situationsWhenPrinting"
                  ></b-form-select>
                </div>

                <div class="selectPlus">
                  <label class="fixedSelect2">Ação após emissão da NF</label>

                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="dataSettings.receita.acaoAposEmissaoNF"
                    :options="optionsToSendNF"
                  ></b-form-select>
                </div>

                <div class="selectPlus">
                  <label class="fixedSelect2">Alerta mínimo de receitas</label>
                  <input
                    required
                    :class="`input borderInput ${isInvalidInput}`"
                    v-model="dataSettings.receita.alertaMinimoReceita"
                    type="number"
                    placeholder="ex: 10"
                  />
                </div>
                <div class="selectPlus">
                  <label class="fixedSelect2">Modelos de Receita</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="dataSettings.receita.modeloReceita"
                    :options="modelosReceita"
                  ></b-form-select>
                </div>
              </div>

              <div class="receitaOptionsGrid">
                <div class="selectPlus">
                  <label class="fixedSelect2" for="quantidade-produtos-receita">
                    Quantidade de produtos por receita
                  </label>
                  <input
                    id="quantidade-produtos-receita"
                    class="input borderInput"
                    v-model.number="dataSettings.receita.quantidadeProdutosPorReceita"
                    type="number"
                    min="1"
                    step="1"
                    placeholder="Sem limite"
                  />
                </div>
                <div class="contentActiveInformationRequiredReceita">
                  <label for="somente-agrotoxicos-mesma-cultura">
                    Permitir somente agrotóxicos da mesma cultura
                    <input
                      id="somente-agrotoxicos-mesma-cultura"
                      type="checkbox"
                      v-model="dataSettings.receita.somenteAgrotoxicosMesmaCultura"
                    />
                  </label>
                </div>
                <div class="contentActiveInformationRequiredReceita">
                  <label for="informacoes-fiscais-receita">
                    Info. fiscais obrigatórias na receita?
                    <input
                      type="checkbox"
                      id="informacoes-fiscais-receita"
                      v-model="dataSettings.receita.informationFiscalRequired"
                    />
                  </label>
                </div>
                <div class="selectPlus">
                  <label class="fixedSelect2" for="codigo-ibge-empresa">Código IBGE Empresa</label>
                  <input
                    id="codigo-ibge-empresa"
                    required
                    class="input borderInput"
                    v-model="dataSettings.cod_ibge_empresa"
                    type="text"
                  />
                </div>
                <div class="contentActiveInformationRequiredReceita">
                  <label for="exibir-cfop-compra-receita">
                    Exibir CFOP de compra do item na receita
                    <input
                      id="exibir-cfop-compra-receita"
                      type="checkbox"
                      v-model="dataSettings.receita.exibirCfopCompraItem"
                    />
                  </label>
                </div>
                <b-button
                  class="btnPrescriptionPresets"
                  @click="openPrescriptionPresets"
                >
                  Itens predefinidos de receita
                </b-button>
              </div>

              <div
                v-if="getCompanyUf === 'MT' || getCompanyUf === 'SC'"
                class="receitaStateGrid"
              >
                <div v-if="getCompanyUf === 'MT'" class="selectPlus">
                  <label class="fixedSelect2">Código HASH Revenda</label>
                  <input
                    required
                    :class="`input borderInput ${isInvalidInput}`"
                    v-model="dataSettings.receita.configMt.hashRevenda"
                    type="text"
                    placeholder="ex: ABC123"
                  />
                </div>
                <div v-if="getCompanyUf === 'SC'" class="selectPlus">
                  <label class="fixedSelect2">Código Registro Empresa</label>
                  <input
                    required
                    :class="`input borderInput ${isInvalidInput}`"
                    v-model="dataSettings.receita.registroEmpresa"
                    type="text"
                    placeholder="ex: ABC123"
                  />
                </div>
                <div v-if="getCompanyUf === 'MT'" class="selectPlus">
                  <label class="fixedSelect2"
                    >CNPJ Recebimento de Emb Vazias</label
                  >
                  <input
                    required
                    :class="`input borderInput ${isInvalidInput}`"
                    v-model="dataSettings.receita.configMt.cnpjUre"
                    type="text"
                    placeholder="ex: ABC123"
                  />
                </div>
              </div>
            </div>

            <div class="rowContainer">
              <span>
                <b-icon-bag-check-fill></b-icon-bag-check-fill> Vendas
              </span>
              <div class="rowContent">
                <div class="selectPlus">
                  <label class="fixedSelect2">Bloquear estoque negativo</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="dataSettings.venda.bloqueio_estoque"
                    :options="blockStock"
                  ></b-form-select>
                </div>

                <div class="selectPlus1">
                  <label class="fixedSelect2">Casas Decimais</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    value-field="value"
                    text-field="text"
                    :options="decimalPlacesOptions"
                    v-model="dataSettings.venda_mtq.casas_decimais"
                  >
                  </b-form-select>
                </div>

                <InputPercentage
                  v-if="enableMtq"
                  label="Porcentagem de perda"
                  type="text"
                  :dataInput.sync="dataSettings.venda_mtq.porcentagem_perda"
                  ref="porcentagem_perda"
                />
              </div>

              <div class="rowContent input-group" style="width: 100%">
                <textarea
                  style="resize: none; height: 100px; width: 100%"
                  required
                  placeholder="Preencha aqui uma observação para ficar salvar por padrão nas suas vendas em (Observações Gerais)"
                  class="borderInput"
                  v-model="dataSettings.venda.dados_adicionais_padrao"
                />
              </div>
            </div>

            <div class="rowContainer">
              <span> <b-icon-receipt></b-icon-receipt> NF-e </span>
              <div class="rowContent">
                <div class="selectPlus">
                  <label class="fixedSelect2">Bloquear estoque zerado ou negativo</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    v-model="dataSettings.nfe.bloqueio_estoque"
                    :options="blockStock"
                  ></b-form-select>
                </div>
              </div>
            </div>

            <div class="rowContainer">
              <span> <b-icon-cash></b-icon-cash> Financeiro </span>
              <div class="rowContent">
                <div class="selectPlus1">
                  <label class="fixedSelect2">Tipo de Chave</label>
                  <b-form-select
                    class="borderInput shadow-none"
                    value-field="value"
                    text-field="text"
                    :options="typesKeyPix"
                    v-model="dataSettings.tipoChave"
                  >
                  </b-form-select>
                </div>
                <div class="input-group">
                  <input
                    required
                    class="input borderInput"
                    v-model="dataSettings.chavePix"
                    type="text"
                  />
                  <label class="user-label"> Chave Pix </label>
                </div>
                <InputPercentage
                  label="Juros"
                  type="text"
                  :dataInput.sync="dataSettings.juros"
                  ref="juros"
                />

                <InputPercentage
                  label="Multa"
                  type="text"
                  :dataInput.sync="dataSettings.multa"
                  ref="multa"
                />
              </div>
            </div>

            <div class="contentCertificateAndVirtualManager">
              <div class="rowContainer">
                <span> <b-icon-star-fill /> Gerente virtual</span>
                <div class="rowContentVirtualManager">
                  <div class="contentEmailAndResume">
                    <div class="input-group" style="width: 100%">
                      <input
                        required
                        :class="`input borderInput ${isInvalidInput}`"
                        v-model="dataSettings.gerente_virtual.email"
                        type="text"
                        ref="email"
                        @blur="clearInvalidInput"
                      />
                      <label class="user-label"> Email </label>
                    </div>

                    <div class="selectPlus">
                      <label class="fixedSelect2">Tipo de relatório</label>
                      <b-form-select
                        :class="`borderInput shadow-none ${isInvalidInput}`"
                        value-field="value"
                        text-field="text"
                        :options="resumeTypes"
                        v-model="dataSettings.gerente_virtual.periodo"
                        ref="periodo"
                        @blur="clearInvalidInput"
                        disabled
                      >
                      </b-form-select>
                    </div>
                  </div>

                  <div class="contentActiveVirtualManager">
                    <label for="active-virtual-manager">
                      Gerente virtual
                      <input
                        type="checkbox"
                        id="active-virtual-manager"
                        v-model="dataSettings.gerente_virtual.ativo"
                      />
                    </label>
                  </div>
                </div>

                <div class="rowContentVirtualManager">
                  <div>
                    <p style="color: rgb(62, 102, 174)">
                      * Ao ativar o <b>gerente virtual</b>, você receberá emails
                      com base no <b>tipo de resumo</b> informado com um resumo
                      das suas movimentações!
                    </p>
                  </div>
                </div>
              </div>

              <div class="rowContainer containerCertificate">
                <span>
                  <b-icon-file-earmark-arrow-up-fill></b-icon-file-earmark-arrow-up-fill>
                  Certificado</span
                >

                <div v-if="isLoading" class="contentLoading">
                  <b-spinner label="Spinning" class="loading" />
                </div>

                <div v-else>
                  <div
                    class="rowContent"
                    v-if="
                      isEnableUpdateCertificate || !certificateExpirationTime
                    "
                  >
                    <div
                      style="
                        width: 100%;
                        display: flex;
                        align-items: center;
                        gap: 1rem;
                        flex-wrap: wrap;
                      "
                    >
                      <div class="contentInputFile">
                        <label
                          for="inputFile"
                          class="labelInputFile"
                          @dragover="handleDragOver"
                          @drop="handleDrop($event)"
                        >
                          <span class="textSelectFile">
                            <b-icon-paperclip scale="1.5" />
                            <p class="m-0 p-0">Escolha seu certificado</p>
                          </span>
                          <span class="textDropFile">{{ getNameFile() }}</span>
                        </label>
                        <input
                          type="file"
                          id="inputFile"
                          name="inputFile"
                          @change="handleFileChange($event)"
                          accept=".pfx"
                        />
                      </div>

                      <div style="width: 100%">
                        <InputPassword
                          label="Senha"
                          :labelFixed="true"
                          :dataInput.sync="dataCertificate.password"
                          style="width: 100%"
                        />
                      </div>

                      <div class="contentBtnsCertificate">
                        <div>
                          <b-button
                            class="btnGeneral btnSendCertificate"
                            size="sm"
                            @click="sendCertificate"
                            >Carregar Certificado</b-button
                          >
                        </div>

                        <div v-if="dataSettings.nome_certificado">
                          <b-button
                            class="btnGeneral btnCancel"
                            size="sm"
                            @click="cancelUpdateCertificate"
                            >Cancelar</b-button
                          >
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="rowContent rowCertificate" v-else>
                    <div>
                      <div class="containerCertificateExpiration mb-3">
                        <div style="font-size: 14px">
                          {{ dataSettings.nome_certificado }}
                        </div>

                        <div class="contentCertificateExpiration">
                          <span>Dias para vencimento: </span>
                          <p>
                            {{ this.certificateExpirationTime }}
                          </p>
                        </div>
                      </div>

                      <div>
                        <label
                          class="btnsUpdateCertificate"
                          for="updateCertificate"
                        >
                          Atualizar Certificado
                          <input
                            type="checkbox"
                            id="updateCertificate"
                            style="display: none"
                            v-model="isEnableUpdateCertificate"
                            @click="enableSendCertificate"
                          />
                        </label>
                      </div>
                    </div>
                  </div>

                  <div class="rowCotent mt-2">
                    <p style="color: #e01515; font-size: 13px">
                      {{ invalidPayloadText }}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div style="width: 100%">
              <div class="mt-2">
                <b-button
                  class="btnGeneral"
                  size="sm"
                  @click="handleSaveOrUpdate"
                  >Salvar</b-button
                >
              </div>
            </div>

            <b-modal
              id="modal-inutilizar"
              hide-footer
              hide-header
              centered
              size="lg"
              title="Inutilizar numeração"
            >
              <div class="contentModal">
                <div class="rowContainer">
                  <span>
                    <b-icon-cash></b-icon-cash> Inutilização de numeração
                  </span>

                  <div class="rowContent">
                    <div class="selectPlus1">
                      <label class="fixedSelect2">Modelo</label>
                      <b-form-select
                        class="borderInput shadow-none"
                        value-field="value"
                        text-field="text"
                        :options="modeloInutilizar"
                        v-model="dataInutilizar.modelo"
                      />
                    </div>

                    <div class="selectPlus1">
                      <label class="fixedSelect2">Ambiente</label>
                      <b-form-select
                        class="borderInput shadow-none"
                        value-field="value"
                        text-field="text"
                        :options="ambiente"
                        v-model="dataInutilizar.ambiente"
                        disabled
                      />
                    </div>

                    <div class="input-group">
                      <input
                        required
                        class="input borderInput"
                        v-model.trim="dataInutilizar.serie"
                        type="text"
                        inputmode="numeric"
                      />
                      <label class="user-label">Série do documento</label>
                    </div>

                    <div class="input-group">
                      <input
                        required
                        class="input borderInput"
                        v-model.trim="dataInutilizar.sequencia"
                        type="text"
                        inputmode="numeric"
                      />
                      <label class="user-label">Sequência (Numeração)</label>
                    </div>
                  </div>

                  <div class="rowContent">
                    <div class="input-group" style="width: 100%">
                      <input
                        required
                        class="input borderInput"
                        v-model.trim="dataInutilizar.motivo"
                        type="text"
                        maxlength="255"
                      />
                      <label class="user-label">Motivo</label>
                    </div>
                  </div>

                  <div class="inutilizationHelp">
                    <p>
                      * O motivo da inutilização deve ter no mínimo 15
                      caracteres.
                    </p>
                    <p>
                      ** Para inutilizar vários números, informe a faixa como no
                      exemplo: 101-109.
                    </p>
                    <p>
                      *** A inutilização comunica à SEFAZ uma quebra de
                      sequência. Os números informados não podem ter sido usados
                      em documento autorizado, cancelado ou denegado.
                    </p>
                  </div>
                </div>

                <div class="btnModal-action-nfe">
                  <button
                    class="btnContentReceive-action-nfe"
                    :disabled="isInutilizing"
                    @click="$bvModal.hide('modal-inutilizar')"
                  >
                    Cancelar
                  </button>
                  <button
                    class="btnContent-action-nfe"
                    :disabled="isInutilizing"
                    @click="inutilizarPut"
                  >
                    {{
                      isInutilizing
                        ? "Inutilizando..."
                        : "Inutilizar numeração"
                    }}
                  </button>
                </div>
              </div>
            </b-modal>
          </div>
        </div>
      </b-card>

      <b-modal
        id="modal-prescription-presets"
        v-model="showPrescriptionPresets"
        dialog-class="prescriptionPresetDialog"
        content-class="prescriptionPresetModalContent"
        body-class="prescriptionPresetModalBody"
        hide-footer
        hide-header
        lazy
        centered
        @hidden="showPrescriptionPresets = false"
      >
        <PrescriptionPresetForm @close="showPrescriptionPresets = false" />
      </b-modal>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import InputPercentage from "../../components/UI/CustomInputs/InputPercentage.vue";
import InputPassword from "../../components/UI/CustomInputs/InputPassword.vue";
import PrescriptionPresetForm from "../Prescription/PrescriptionPresetForm.vue";

import ServiceWebMania from "../../services/serviceWebMania";
import ServiceSettings from "../../services/serviceSettings";
import serviceNotaFiscal from "../../services/serviceNotaFiscal";

import { ValidateVirtualManager } from "../../validators/virtualManager";
import { convertFileToBase64 } from "../../utils/convertFileToBase64";
import {
  resumeTypes,
  typesKeyPix,
  decimalPlacesOptions,
} from "../../common/index";

export default {
  components: {
    InputPercentage,
    InputPassword,
    PrescriptionPresetForm,
  },
  data() {
    return {
      imgBase64: null,
      textLogo: "Click me",
      classImg: "logo_img",
      alert: alert,
      imgFromBackend: null,
      dataCertificate: {
        base64: null,
        password: null,
      },
      dataSettings: {
        id: null,
        nome_certificado: null,
        gerente_virtual: {
          email: "",
          ativo: false,
          periodo: "diario",
        },
        juros: 0,
        multa: 0,
        chavePix: "",
        tipoChave: 1,
        cod_ibge_empresa: null,
        emissao_fiscal: {
          ambiente: "2",
          infoAgroNfe: false,
          selecionarProdutosAoTransformarVenda: false,
        },
        venda: {
          bloqueio_estoque: "1",
          dados_adicionais_padrao: "",
        },
        nfe: {
          dados_adicionais_padrao: "",
          bloqueio_estoque: "1",
        },
        venda_mtq: {
          casas_decimais: "2",
          porcentagem_perda: "0",
          dados_adicionais_padrao: "",
        },
        receita: {
          situacaoAoImprimir: "Rascunho",
          situacaoAoEmitirNfe: "Rascunho",
          acaoAposEmissaoNF: null,
          alertaMinimoReceita: null,
          quantidadeProdutosPorReceita: null,
          somenteAgrotoxicosMesmaCultura: false,
          exibirCfopCompraItem: false,
          dadosAdicionaisPadrao: null,
          modeloReceita: "P1",
          registroEmpresa: "",
          configMt: {
            hashRevenda: "",
            cnpjUre: "",
          },
        },
      },
      modelosReceita: [
        { text: "Padrão", value: "P1" },
        { text: "Padrão 2", value: "P2" },
        { text: "Padrão 3", value: "P3" },
        { text: "Padrão econômico matricial", value: "PEM" },
        { text: "Ceará 2 Novo", value: "CE2" },
        { text: "Bahia", value: "BA" },
        { text: "Espiríto Santo", value: "ES" },
        { text: "Minas Gerais", value: "MG3" },
        { text: "Santa Catarina", value: "SC" },
      ],
      ambiente: [
        { text: "Produção", value: "1" },
        { text: "Homologação", value: "2" },
      ],
      modeloInutilizar: [
        { text: "NF-e", value: "1" },
        { text: "NFC-e", value: "2" },
      ],
      dataInutilizar: {
        sequencia: "",
        motivo: "",
        ambiente: "2",
        serie: "",
        modelo: "1",
      },
      isInutilizing: false,
      blockStock: [
        { text: "Não", value: "1" },
        { text: "Sim", value: "2" },
      ],
      situationsWhenPrinting: [
        { value: "Rascunho", text: "Rascunho" },
        { value: "Finalizado(a)", text: "Finalizado(a)" },
        { value: "Cancelado", text: "Cancelado" },
      ],
      optionsToSendNF: [
        { value: null, text: "Selecione..." },
        { value: "imprimirReceita", text: "Imprimir Receita" },
        { value: "assinarReceita", text: "Imprimir e Assinar Receita" },
      ],
      certificateExpirationTime: null,
      fileName: null,
      isEnableUpdateCertificate: false,
      invalidPayloadText: "",
      isLoading: false,
      objectPlan: {},
      resumeTypes: resumeTypes,
      typesKeyPix: typesKeyPix,
      decimalPlacesOptions: decimalPlacesOptions,
      isInvalidInput: "",
      spinGeneral: false,
      showPrescriptionPresets: false,
    };
  },
  methods: {
    ...mapMutations(["SET_DATA_CONFIG"]),
    openPrescriptionPresets() {
      this.showPrescriptionPresets = true;
    },
    async save() {
      try {
        const id = await ServiceSettings.save(this.dataSettings);
        this.dataSettings.id = id;

        this.SET_DATA_CONFIG(this.dataSettings);
        this.$toast.open({
          message: "Configurações salvas!",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um erro ao salvar as configurações",
          type: "info",
        });
      }
    },

    async update() {
      try {
        await ServiceSettings.update(this.dataSettings);
        this.SET_DATA_CONFIG(this.dataSettings);

        this.$toast.open({
          message: "Configurações Atualizadas!",
          type: "success",
        });
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um erro ao atualizar as configurações",
          type: "info",
        });
      }
    },

    async sendCertificate() {
      try {
        if (!this.valdatePayloadCertificate()) {
          return;
        }

        this.dataSettings.nome_certificado = this.getNameFile();
        await ServiceWebMania.sendCertificado({
          ...this.dataCertificate,
          dataSettings: this.dataSettings,
        });

        this.isEnableUpdateCertificate = false;
        this.invalidPayloadText = "";
        return this.$toast.open({
          message: "Certificado carregado com sucesso!",
          type: "success",
        });
      } catch (error) {
        return this.$toast.open({
          message:
            error.response.data.message || "Erro ao carregar o certificado",
          type: "success",
        });
      }
    },

    async findCertificateExpirationTime() {
      try {
        this.isLoading = true;
        this.certificateExpirationTime =
          await ServiceWebMania.findCertificateExpirationTime();

        if (!this.certificateExpirationTime)
          this.isEnableUpdateCertificate = true;
      } catch (error) {
        this.$toast.open({
          message: "Erro ao buscar tempo de expiração do certificado",
          type: "info",
        });
      } finally {
        this.isLoading = false;
      }
    },

    async verifyExistsSetitngs() {
      const result = await ServiceSettings.findSettingsAtm();

      if (result && Object.keys(result).length) {
        this.dataSettings.id = result.id;
        this.dataSettings.nome_certificado = result?.nome_certificado;
        if (result?.gerente_virtual) {
          this.dataSettings.gerente_virtual = result?.gerente_virtual;
        }

        if (result?.venda_mtq) {
          this.dataSettings.venda_mtq = result?.venda_mtq;
        }

        if (result?.nfe) {
          this.dataSettings.nfe = {
            ...this.dataSettings.nfe,
            ...result.nfe,
          };
        }

        if (result?.receita) {
          this.dataSettings.receita = {
            ...this.dataSettings.receita,
            ...result?.receita,
            exibirCfopCompraItem: result?.receita.exibirCfopCompraItem === true,
            configMt: result?.receita.configMt || {
              hashRevenda: "",
              cnpjUre: "",
            },
          };
        }

        this.dataSettings.juros = result?.juros;
        this.dataSettings.multa = result?.multa;
        this.dataSettings.chavePix = result?.chavePix;
        this.dataSettings.tipoChave = result?.tipoChave;
        this.dataSettings.cod_ibge_empresa = result?.cod_ibge_empresa;
        this.dataSettings.emissao_fiscal = {
          ...this.dataSettings.emissao_fiscal,
          ...result?.emissao_fiscal,
          selecionarProdutosAoTransformarVenda:
            result?.emissao_fiscal?.selecionarProdutosAoTransformarVenda ||
            false,
        };
        this.dataSettings.venda.dados_adicionais_padrao =
          result?.venda?.dados_adicionais_padrao;
        this.dataSettings.venda.bloqueio_estoque =
          result?.venda.bloqueio_estoque;

        this.$refs.juros.valueInput = result?.juros;
        this.$refs.multa.valueInput = result?.multa;

        if (this.enableMtq) {
          this.$refs.porcentagem_perda.valueInput =
            result?.venda_mtq.porcentagem_perda;
        }
      }
    },

    handleSaveOrUpdate() {
      const limit = this.dataSettings.receita.quantidadeProdutosPorReceita;
      if (limit !== null && limit !== "" && limit !== undefined &&
          (!Number.isInteger(Number(limit)) || Number(limit) < 1)) {
        return this.$toast.open({
          message: "Informe uma quantidade de produtos por receita maior que zero e sem decimais.",
          type: "info",
        });
      }
      this.dataSettings.receita.quantidadeProdutosPorReceita =
        limit === "" || limit === undefined ? null : limit;

      if (this.dataSettings.gerente_virtual.ativo) {
        const isNotValid = ValidateVirtualManager(
          this.dataSettings.gerente_virtual
        );

        if (isNotValid && Object.keys(isNotValid).length) {
          this.handleFocus(isNotValid.keyError);

          return this.$toast.open({
            message: isNotValid.message,
            type: "info",
          });
        }
      }

      if (!this.dataSettings.venda_mtq.casas_decimais) {
        this.dataSettings.venda_mtq.casas_decimais = 2;
      }

      this.dataSettings.id ? this.update() : this.save();
    },

    handleFocus(refName) {
      this.$refs[refName].focus();

      this.isInvalidInput = "isInvalidInput";
    },

    cancelUpdateCertificate() {
      this.isEnableUpdateCertificate = false;
      this.invalidPayloadText = "";
    },

    handleDragOver(event) {
      event.preventDefault();
    },

    async handleDrop(event) {
      event.preventDefault();
      this.dataCertificate.base64 = await convertFileToBase64(
        event.target.files[0]
      );
      this.fileName = event.target.files[0].name;
    },

    async handleFileChange(event) {
      this.dataCertificate.base64 = await convertFileToBase64(
        event.target.files[0]
      );
      this.fileName = event.target.files[0].name;
    },

    clearInvalidInput() {
      this.isInvalidInput = "";
    },

    valdatePayloadCertificate() {
      if (!this.dataCertificate.base64) {
        this.invalidPayloadText = "* Certificado deve ser selecionado!";
        return false;
      } else if (!this.dataCertificate.password) {
        this.invalidPayloadText = "* Senha do certificado deve ser preenchida!";
        return false;
      }

      return true;
    },

    enableSendCertificate() {
      this.isEnableUpdateCertificate = true;
    },

    getNameFile() {
      if (this.fileName) {
        return this.fileName;
      }

      return "Ou arraste e solte aqui";
    },

    openInutilizarModal() {
      this.dataInutilizar.ambiente =
        this.dataSettings.emissao_fiscal.ambiente;
      this.$bvModal.show("modal-inutilizar");
    },

    validateInutilization() {
      const { serie, sequencia, motivo } = this.dataInutilizar;

      if (!/^\d+$/.test(serie)) {
        return "Informe a série do documento.";
      }

      const sequenceMatch = sequencia.match(/^(\d+)(?:-(\d+))?$/);
      if (!sequenceMatch) {
        return "Informe uma numeração ou faixa válida. Exemplo: 101-109.";
      }

      const initialNumber = Number(sequenceMatch[1]);
      const finalNumber = Number(sequenceMatch[2] || sequenceMatch[1]);
      if (initialNumber < 1 || finalNumber < initialNumber) {
        return "A faixa de numeração informada é inválida.";
      }

      if (motivo.length < 15) {
        return "O motivo deve ter no mínimo 15 caracteres.";
      }

      return null;
    },

    getInutilizationMessage(data) {
      return (
        data?.error ||
        data?.log?.xMotivo ||
        data?.log?.evento?.[0]?.xMotivo ||
        data?.motivo ||
        data?.message ||
        "A SEFAZ não homologou a inutilização."
      );
    },

    async inutilizarPut() {
      const validationMessage = this.validateInutilization();
      if (validationMessage) {
        return this.$toast.open({
          message: validationMessage,
          type: "info",
        });
      }

      try {
        this.isInutilizing = true;
        const data = await serviceNotaFiscal.inutilizar(this.dataInutilizar);
        const cStat = String(
          data?.cStat ||
            data?.log?.cStat ||
            data?.log?.evento?.[0]?.cStat ||
            ""
        );

        if (cStat !== "102") {
          return this.$toast.open({
            message: this.getInutilizationMessage(data),
            type: "error",
          });
        }

        this.$toast.open({
          message: this.getInutilizationMessage(data),
          type: "success",
        });
        this.clearInutilization();
      } catch (error) {
        this.$toast.open({
          message: this.getInutilizationMessage(error?.response?.data),
          type: "error",
        });
      } finally {
        this.isInutilizing = false;
      }
    },

    clearInutilization() {
      this.dataInutilizar = {
        sequencia: "",
        motivo: "",
        ambiente: this.dataSettings.emissao_fiscal.ambiente,
        serie: "",
        modelo: "1",
      };
      this.$bvModal.hide("modal-inutilizar");
    },
  },
  computed: {
    ...mapState({
      dataConfig: (state) => state.dataConfig,
      enableMtq: (state) => state.enableMtq,
      dataCompany: (state) => state.dataCompany,
    }),

    getCompanyUf() {
      return this.dataCompany?.uf?.toUpperCase() || "";
    },
  },
  mounted() {
    this.findCertificateExpirationTime();
    this.verifyExistsSetitngs();
  },
};
</script>

<style scoped>
.container-geral {
  width: 100% !important;
}

.container-components {
  width: 87%;
  transition: all 0.7s ease-in-out;
}

.generalContent {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

@media screen and (max-width: 1028px) {
  .generalContent {
    flex-direction: column;
    gap: 20px;
  }
}

span {
  font-weight: bold;
  cursor: context-menu;
  font-size: 13px;
}

.user-label {
  position: absolute;
  left: 10px;
  font-size: 11px;
  bottom: 7px;
  pointer-events: none;
  transform: translateY(0.5rem);
  transition: 150ms cubic-bezier(0.4, 0, 0.2, 1);
  white-space: nowrap !important;
  text-overflow: ellipsis;
  color: #666360;
}

.input {
  font-size: 12px !important;
  width: 100%;
}

.input:focus ~ label,
input:valid ~ label {
  transform: translateY(-50%) scale(0.8);
  background-color: #ffffff;
  padding: 0 0.1em;
}

.borderInput {
  font-size: 12px;
  height: 30px;
  border: 1px solid #b2b2b2;
  border-radius: 5px;
  outline: none;
  transition: ease-in 0.1s all;
  padding-left: 5px;
  padding-right: 4px;
  color: #5c5855;
}

.borderInput:focus {
  border: 1px solid #505050;
}

.rowContainer {
  position: relative;
  border: 1px solid rgb(230, 230, 230);
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  padding: 10px 10px 5px 10px;
  background: #f9f9f94d;
  margin-bottom: 6px;
  width: 100%;
}

.rowContent {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  gap: 10px;
}

.receitaMainGrid,
.receitaOptionsGrid,
.receitaStateGrid {
  display: grid;
  width: 100%;
  gap: 12px;
  padding: 12px 0 5px;
  align-items: stretch;
}

.receitaMainGrid {
  grid-template-columns: repeat(3, minmax(0, 1.2fr)) minmax(0, 0.9fr) minmax(0, 1.2fr);
}

.receitaOptionsGrid {
  grid-template-columns: minmax(190px, 1.05fr) minmax(220px, 1.4fr) minmax(210px, 1.3fr) minmax(150px, 0.85fr) minmax(165px, 1fr);
}

.receitaStateGrid {
  grid-template-columns: repeat(2, minmax(0, 240px));
}

.receitaSettings .selectPlus,
.receitaSettings .contentActiveInformationRequiredReceita {
  width: 100%;
  min-width: 0;
}

.receitaSettings .selectPlus > input,
.receitaSettings .selectPlus > select,
.receitaSettings .contentActiveInformationRequiredReceita label {
  width: 100%;
}

.receitaSettings .contentActiveInformationRequiredReceita label {
  justify-content: space-between;
  gap: 8px;
  min-height: 34px;
  font-size: 11px;
}

.receitaSettings .contentActiveInformationRequiredReceita input {
  flex: 0 0 18px;
  margin: 0;
}

.receitaSettings .btnPrescriptionPresets {
  min-height: 34px;
}

.rowContentVirtualManager {
  display: flex;
  width: 100%;
  padding: 10px 0 5px 0;
  gap: 1rem;
}

.contentEmailAndResume {
  width: 100%;
  display: flex;
  gap: 1rem;
}

.btnGeneral {
  border-radius: 5px;
  background-color: whitesmoke;
  width: 165px;
  border: none;
  color: rgb(29, 120, 21);
  font-size: 12px;
  border: 1px solid rgb(29, 120, 21);
}

.btnGeneral:hover {
  background-color: rgb(233, 255, 223);
  color: rgb(29, 120, 21);
}

.btnInutilizar {
  border-radius: 5px;
  background-color: whitesmoke;
  border: 1px solid #d5d3d3;
  color: rgb(82, 82, 82);
  font-size: 12px;
}

.btnInutilizar:hover {
  background-color: rgb(224, 224, 224);
  border-color: #d5d3d3;
  color: rgb(82, 82, 82);
}

.btnPrescriptionPresets {
  background-color: #006458;
  border: 1px solid #006458;
  border-radius: 5px;
  color: #fff;
  font-size: 12px;
}

.btnPrescriptionPresets:hover,
.btnPrescriptionPresets:focus {
  background-color: #007c6d;
  border-color: #007c6d;
  box-shadow: none;
}

::v-deep(.prescriptionPresetDialog) {
  max-width: calc(100vw - 80px);
  width: 100%;
}

::v-deep(.prescriptionPresetModalContent) {
  height: calc(100vh - 40px);
  overflow: hidden;
}

::v-deep(.prescriptionPresetModalBody) {
  height: 100%;
  overflow: hidden;
  padding: 0;
}

.inutilizationHelp {
  display: flex;
  flex-direction: column;
  padding-top: 35px;
  color: #141479;
  font-size: 13px;
}

.btnModal-action-nfe {
  margin: 10px 0 20px;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  gap: 10px;
}

.btnContentReceive-action-nfe,
.btnContent-action-nfe {
  border: 1px solid #00486e;
  border-radius: 3px;
  width: 45%;
  min-height: 32px;
  font-size: 11px;
}

.btnContentReceive-action-nfe {
  color: #00486e;
  background: white;
}

.btnContent-action-nfe {
  color: #ffffff;
  background: #00486e;
}

.btnContentReceive-action-nfe:disabled,
.btnContent-action-nfe:disabled {
  cursor: not-allowed;
  opacity: 0.65;
}

.btnCancel {
  background-color: rgb(172, 55, 55);
  color: white;
}

.btnCancel:hover {
  background-color: rgb(144, 45, 45);
  color: white;
}

.btnsUpdateCertificate {
  text-align: center;
  padding: 0.5rem;
  border-radius: 5px;
  background-color: whitesmoke;
  width: 100%;
  border: none;
  color: rgb(29, 120, 21);
  font-size: 12px;
  border: 1px solid rgb(29, 120, 21);
  cursor: pointer;
}

.btnsUpdateCertificate:hover {
  background-color: rgb(233, 255, 223);
  color: rgb(29, 120, 21);
}

.input-group {
  width: 30%;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 0 0 0 1rem;
  padding-left: 0 !important;
}

.card {
  border: none !important;
}

/* INPUT FILE */

.contentBtnsCertificate {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.contentInputFile {
  display: flex;
  gap: 5px;
  align-items: center;
}

input[type="file"] {
  display: none;
}

.labelInputFile {
  width: 400px;
  min-width: 400px;
  display: flex;
  align-items: center;
  gap: 5px;
  border: dashed 1px #c1c1c1;
  border-radius: 5px;
  cursor: pointer !important;
  margin: 0;
}

.textSelectFile {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-bottom: 0;
  background-color: #c1c1c156;
  border-radius: 5px;
  font-weight: bold;
  font-size: 11px;
  padding: 5.75px 9px;
  cursor: pointer;
}

.textSelectFile p {
  font-weight: 600;
  font-family: Poppins-Regular, sans-serif !important;
}

.textDropFile {
  max-width: 230px !important;
  overflow: hidden;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-weight: normal;
  cursor: pointer;
}

/* INPUT FILE */

.contentCertificateAndVirtualManager {
  width: 100%;
  display: flex;
  gap: 1rem;
}

.containerCertificate {
  width: 40%;
  min-width: 420px;
}

.contentCertificateExpiration {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  background-color: rgb(62, 102, 174);
  color: white;
  padding: 0.25rem;
  border-radius: 5px;
}

.contentCertificateExpiration span {
  font-weight: normal;
}

.contentCertificateExpiration p {
  padding: 0 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 20px;
  margin: 0;
  font-weight: normal;
  background-color: rgb(187, 31, 31);
  border-radius: 5px;
  font-size: 14px;
}

.fixedSelect2 {
  position: absolute;
  margin-bottom: 0px;
  font-size: 9.5px;
  bottom: 22px;
  left: 11px;
  z-index: 2;
  text-transform: capitalize;
  color: rgb(85, 81, 81);
  background-color: white;
}

.rowCertificate {
  justify-content: center;
}

.containerCertificateExpiration {
  max-width: 280px;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem;
  border-radius: 5px;
  box-shadow: 0 0 2.5px 0 rgba(0, 0, 0, 0.545);
}

.contentLoading {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 180px;
}

.loading {
  width: 100px;
  height: 100px;
}

.contentActiveInformationRequiredReceita {
  min-width: 179px;
  display: flex;
}

.contentActiveInformationRequiredReceita label {
  margin: 0;
  display: flex;
  align-items: center;
  font-size: 13px;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  color: #666360;
  border-radius: 5px;
  gap: 15px;
  color: #666360;
  background-color: whitesmoke;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.135);
  padding: 5px;
  cursor: pointer;
}

.contentActiveInformationRequiredReceita input {
  width: 18px !important;
  height: 18px !important;
  cursor: pointer;
}

.contentActiveVirtualManager {
  min-width: 179px;
  display: flex;
}

.contentActiveVirtualManager label {
  margin: 0;
  display: flex;
  align-items: center;
  font-size: 13px;
  font-family: Poppins-Regular, sans-serif !important;
  font-weight: 600;
  color: #006256;
  border-radius: 5px;
  gap: 15px;
  color: #006256;
  background-color: whitesmoke;
  box-shadow: 0 0 2px 1px rgba(0, 0, 0, 0.135);
  padding: 5px;
  cursor: pointer;
}

.contentActiveVirtualManager input {
  width: 18px !important;
  height: 18px !important;
  cursor: pointer;
}

.selectPlus {
  position: relative;
  width: 40%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.selectPlus1 {
  position: relative;
  width: 20%;
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.decimalPlaces {
  width: 20%;
}

.isInvalidInput:focus {
  border: solid 1px rgba(204, 21, 21, 0.583) !important;
  transition: ease-in all 0.1s;
  box-shadow: 0 0 2px 1px rgba(204, 21, 21, 0.583) !important;
}

@media screen and (max-width: 1150px) {
  .receitaMainGrid,
  .receitaOptionsGrid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .receitaMainGrid > :last-child,
  .receitaOptionsGrid > :last-child {
    grid-column: span 2;
  }
}

@media screen and (max-width: 750px) {
  .receitaMainGrid,
  .receitaOptionsGrid,
  .receitaStateGrid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .receitaMainGrid > :last-child {
    grid-column: span 2;
  }

  .receitaOptionsGrid > :last-child {
    grid-column: span 2;
  }
}

@media screen and (max-width: 540px) {
  .receitaMainGrid,
  .receitaOptionsGrid,
  .receitaStateGrid {
    grid-template-columns: minmax(0, 1fr);
  }

  .receitaMainGrid > :last-child,
  .receitaOptionsGrid > :last-child {
    grid-column: auto;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .container-components {
    width: 100%;
  }
  .generalContent {
    gap: 5px;
  }
  .rowContainer {
    padding: 5px;
  }
  .rowContainer span {
    font-size: 12px;
  }
  .rowContent {
    padding: 5px 0 5px 0;
    gap: 5px;
  }
  .containerCertificateExpiration {
    gap: 0px;
    padding: 5px;
  }
  .btnsUpdateCertificate {
    padding: 5px;
    font-size: 11px;
  }
}

@media screen and (max-width: 1150px) and (min-width: 930px) {
  .rowContentVirtualManager {
    flex-direction: column;
  }

  .selectPlus {
    min-width: 120px;
  }
}

@media screen and (max-width: 930px) and (min-width: 750px) {
  .rowContentVirtualManager {
    flex-direction: column;
  }

  .contentEmailAndResume {
    flex-direction: column;
  }

  .selectPlus {
    width: 100%;
  }
}

@media screen and (max-width: 700px) {
  .container-components {
    width: 100%;
  }

  .rowContentVirtualManager {
    flex-direction: column;
  }

  .selectPlus {
    min-width: 120px;
  }
}

@media screen and (max-width: 750px) {
  .contentCertificateAndVirtualManager {
    flex-direction: column;
  }

  .containerCertificate,
  .contentInputFile,
  .labelInputFile {
    width: 100%;
    min-width: 100%;
  }

  .decimalPlaces {
    width: 20%;
  }
}

@media screen and (max-width: 430px) {
  .contentBtnsCertificate div,
  .btnSendCertificate,
  .btnCancel {
    width: 100% !important;
  }

  .contentBtnsCertificate {
    gap: 1rem;
  }

  .rowContentVirtualManager {
    flex-direction: column;
  }

  .contentEmailAndResume {
    flex-direction: column;
  }

  .selectPlus {
    width: 100%;
  }
}

@media screen and (max-width: 650px) {
  .rowContent {
    flex-direction: column;
  }

  .input-group {
    width: 100%;
  }

  .selectPlus1 {
    width: 100%;
  }
}
</style>
